function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M16.19 2H7.82C4.18 2 2.01 4.17 2.01 7.81v8.37c0 3.64 2.17 5.81 5.81 5.81h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.17 14.09c.19 0 .38-.07.53-.22l4.38-4.38v2.43c0 .41.34.75.75.75s.75-.34.75-.75V7.68c0-.1-.02-.19-.06-.29a.783.783 0 00-.41-.41.717.717 0 00-.29-.06h-4.24c-.41 0-.75.34-.75.75s.34.75.75.75h2.43L8.63 12.8c-.29.29-.29.77 0 1.06.16.16.35.23.54.23zm9.54 2.19a.749.749 0 00-.95-.47 18.333 18.333 0 01-11.53 0 .753.753 0 00-.95.47c-.13.39.08.82.47.95 2.01.67 4.12 1.01 6.24 1.01s4.23-.34 6.24-1.01c.4-.14.61-.56.48-.95z"
})));